import { AbstractControl, ValidatorFn } from "@angular/forms";

export function ValueValidator():ValidatorFn {
    
    return (control:AbstractControl): {[key:string]:any} | null => {
        const error = {};
        const eventfield = control.get('eventField').value
        const operatorarr = control.get('operator').value;
        const operator = operatorarr ? operatorarr[0] : "";
        const conditionvalue = control.get('conditionValue').value;
        if(eventfield?.type != 'timestamp'){
            if(eventfield && !conditionvalue.length){
                error["valueRequired"] = true;
            }
            if(eventfield && (operator == "=" || operator == "!=")  && conditionvalue.length != 1){
                error['singlevalue'] = true;
            }
            if(conditionvalue.length > 50){
                error["valuelength"] = true;
            }
            return error
        }
    }
}